import React from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@material-ui/core';

type ConfirmDialogProps = {
    open: boolean;
    title: React.ReactNode;
    content: React.ReactNode;
    onCancel: React.ComponentProps<typeof Button>['onClick'];
    onConfirm: React.ComponentProps<typeof Button>['onClick'];
    onClose: React.ComponentProps<typeof Dialog>['onClose'];
    confirmLabel: React.ReactNode;
    cancelLabel: React.ReactNode;
    disableBackdropClick: boolean;
    container?: React.ComponentProps<typeof Dialog>['container'];
};

const ConfirmDialog = ({
    container,
    open,
    title,
    onCancel,
    onConfirm,
    onClose,
    content,
    confirmLabel,
    cancelLabel,
    disableBackdropClick = false,
}: ConfirmDialogProps): React.ReactElement => (
    <Dialog
        container={container}
        open={open}
        onClose={onClose}
        disableBackdropClick={disableBackdropClick}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
    >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
            {typeof content === 'string' ? (
                <DialogContentText id="alert-dialog-description">{content}</DialogContentText>
            ) : (
                content
            )}
        </DialogContent>
        <DialogActions>
            <Button id="yeself-button" onClick={onCancel} color="primary">
                {cancelLabel}
            </Button>
            <Button id="yeself-button" onClick={onConfirm} color="primary" autoFocus>
                {confirmLabel}
            </Button>
        </DialogActions>
    </Dialog>
);

export default ConfirmDialog;
